import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import ButtonRounded from "../../components/ButtonRounded";
import ModalContainer from "../../components/ModalContainer";
import {useModalSimpleStyles} from "../../common/styles/modalStyles";

const useStyles = useModalSimpleStyles;

interface ModalDeleteVolumeInMandateProps {
  open: boolean;
  onClose: () => void;
  handleDelete: () => void;
}

const ModalDeleteVolumeInMandate: React.FC<ModalDeleteVolumeInMandateProps> = ({
  open,
  onClose,
  handleDelete,
}) => {
  const [isError, setIsError] = useState<boolean>(false);
  const classes = useStyles();

  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      title="Delete volume"
    >
      <div className={classes.modalContent}>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete the volumes? This will reset all your progress on this mandate allocation.
        </Typography>
        <Grid
          container
          alignItems="center"
          direction="column"
          spacing={2}
          className={classes.userContainer}
        >
        </Grid>
        <Grid container spacing={2} className={classes.btnContainer}>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="outlined"
              onClick={onClose}
              color="default"
            >
              Cancel
            </ButtonRounded>
          </Grid>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="contained"
              color="secondary"
              onClick={handleDelete}
              disabled={isError}
            >
              Delete
            </ButtonRounded>
          </Grid>
        </Grid>
        {isError && (
          <Typography align="center" variant="body2" color="error">
            Failed to delete this file.
          </Typography>
        )}
      </div>
    </ModalContainer>
  );
};

export default ModalDeleteVolumeInMandate;
